// App shell dimensions in MUI spacing units (1 unit = 8px)
export const APPBAR_HEIGHT = 9; // 72px
export const DRAWER_WIDTH = 31; // 248px
export const DRAWER_WIDTH_COLLAPSED = 10; // 80px icon rail
